import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import { required } from '../../shared/forms/validators';

const schema = [
  {
    name: 'chartName',
    component: InputFormik,
    meta: { label: 'Chart Name' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
];

export default schema;
